import { RADashboardTheme } from '@/interfaces/raDashboard.interface'
import Tooltip from '@mui/material/Tooltip'
import React from 'react'

interface DashboardEditControlsProps {
  theme: RADashboardTheme
  editingEnabled: boolean
  isDashboardEditing: boolean
  canEdit: boolean
  isSaving?: boolean
  onStartEditing: () => void
  onCancelEditing: () => void
  onSaveEditing: () => void
  onAddCard: () => void
}

const DashboardEditControls: React.FC<DashboardEditControlsProps> = ({
  theme,
  editingEnabled,
  isDashboardEditing,
  canEdit,
  isSaving,
  onStartEditing,
  onCancelEditing,
  onSaveEditing,
  onAddCard,
}) => {
  if (!editingEnabled) return null

  if (!isDashboardEditing) {
    return (
      <Tooltip
        arrow
        title={canEdit ? '' : "This dashboard can't be edited here. Go to Dashboard Manager to save an editable copy"}
      >
        <span>
          <button
            onClick={onStartEditing}
            disabled={!canEdit}
            style={{
              padding: '8px 16px',
              border: `1px solid ${theme.border}`,
              borderRadius: '8px',
              fontSize: '14px',
              fontWeight: '600',
              backgroundColor: theme.cardBackground,
              color: theme.textPrimary,
              cursor: canEdit ? 'pointer' : 'not-allowed',
              opacity: canEdit ? 1 : 0.6,
            }}
          >
            Edit Dashboard
          </button>
        </span>
      </Tooltip>
    )
  }

  return (
    <>
      <button
        onClick={onAddCard}
        disabled={isSaving}
        style={{
          padding: '8px 16px',
          border: `1px solid ${theme.border}`,
          borderRadius: '8px',
          fontSize: '14px',
          fontWeight: '600',
          backgroundColor: theme.cardBackground,
          color: theme.textPrimary,
          cursor: isSaving ? 'not-allowed' : 'pointer',
          opacity: isSaving ? 0.6 : 1,
        }}
      >
        + Add Card
      </button>
      <button
        onClick={onCancelEditing}
        disabled={isSaving}
        style={{
          padding: '8px 16px',
          border: `1px solid ${theme.border}`,
          borderRadius: '8px',
          fontSize: '14px',
          fontWeight: '600',
          backgroundColor: theme.cardBackground,
          color: theme.textPrimary,
          cursor: isSaving ? 'not-allowed' : 'pointer',
          opacity: isSaving ? 0.6 : 1,
        }}
      >
        Exit Editing
      </button>
      <button
        onClick={onSaveEditing}
        disabled={isSaving}
        style={{
          padding: '8px 16px',
          border: 'none',
          borderRadius: '8px',
          fontSize: '14px',
          fontWeight: '600',
          backgroundColor: theme.runButtonBackground,
          color: theme.runButtonColor,
          cursor: isSaving ? 'not-allowed' : 'pointer',
          opacity: isSaving ? 0.6 : 1,
        }}
      >
        {isSaving ? 'Saving...' : 'Save & Exit'}
      </button>
    </>
  )
}

export default DashboardEditControls
